import { render, staticRenderFns } from "./DepartmentFeaturedIcon.vue?vue&type=template&id=8af7ba80"
import script from "./DepartmentFeaturedIcon.vue?vue&type=script&lang=js"
export * from "./DepartmentFeaturedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports